import { render, staticRenderFns } from "./BasisCopyBookCard.vue?vue&type=template&id=4e6cbd56&scoped=true&"
import script from "./BasisCopyBookCard.vue?vue&type=script&lang=js&"
export * from "./BasisCopyBookCard.vue?vue&type=script&lang=js&"
import style0 from "./BasisCopyBookCard.vue?vue&type=style&index=0&id=4e6cbd56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6cbd56",
  null
  
)

export default component.exports